import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const Navbar = ({ theme = 'light' }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [mobileMenuOpen]);

  // Close mobile drawer on route change
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  const isWhyWeWin = location.pathname === '/why-we-win';
  const isPricing = location.pathname === '/packages';

  return (
    <div className={`public-navbar-container ${theme === 'dark' ? 'dark-theme' : ''}`}>
      <div className="container">
        <nav className="public-navbar">
          <Link to="/" className="nav-logo">
            <img
              src="/text_logo_transparent.png"
              alt="RoofingAssist.AI"
              style={{
                height: 34,
                display: 'block',
                // Navy wordmark is invisible on dark backgrounds — render it white
                ...(theme === 'dark' ? { filter: 'brightness(0) invert(1)' } : {}),
              }}
            />
          </Link>

          <div className="nav-links">
            <Link 
              to="/why-we-win" 
              className={`nav-link ${isWhyWeWin ? 'active' : ''}`}
            >
              Why We Win
            </Link>
            <Link
              to="/packages"
              className={`nav-link ${isPricing ? 'active' : ''}`}
            >
              Packages
            </Link>
            <Link
              to="/login"
              className="nav-link" 
              style={{ fontWeight: 600, marginLeft: '12px' }}
            >
              Login
            </Link>
            <Link 
              to="/book" 
              className="btn-primary" 
              style={{ padding: '10px 24px' }}
            >
              Book a Call
            </Link>
          </div>

          <button 
            className={`mobile-menu-toggle ${mobileMenuOpen ? 'open' : ''}`}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle navigation menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </nav>
      </div>

      {/* Mobile Drawer Overlay */}
      <div className={`mobile-drawer ${mobileMenuOpen ? 'open' : ''}`}>
        <Link 
          to="/why-we-win" 
          className={`mobile-drawer-link ${isWhyWeWin ? 'active' : ''}`}
          onClick={() => setMobileMenuOpen(false)}
        >
          Why We Win
        </Link>
        <Link
          to="/packages"
          className={`mobile-drawer-link ${isPricing ? 'active' : ''}`}
          onClick={() => setMobileMenuOpen(false)}
        >
          Packages
        </Link>
        <Link
          to="/login"
          className="mobile-drawer-link" 
          onClick={() => setMobileMenuOpen(false)}
        >
          Login
        </Link>
        <Link 
          to="/book" 
          className="mobile-drawer-btn" 
          onClick={() => setMobileMenuOpen(false)}
        >
          Book a Call &rarr;
        </Link>
      </div>
    </div>
  );
};

export default Navbar;
